import { InternalAxiosRequestConfig } from "axios";
import {
  PASSWORD_ENCRYPT_LIST,
  HANDLE_SPEED_UP_LIST,
  HANDLE_SPEED_UP_LIST_OPERATION,
  SPECIAL_HUAWEI,
  // NEED_ACCESS_ID_LIST,
} from "../constants/default";
// import { STORAGE } from "project-config/constants";
// import Cookie from "project-config/utils/cookie";
import { sha1Encrypt } from "project-config/utils/encrypt";
import { STORAGE } from "project-config/constants";
import getHttpHeader from "project-config/services/request/get-http-header";

// 密码加盐
export function requestInterceptorsPassword(
  config: InternalAxiosRequestConfig
) {
  if (!config.url) return config;

  if (PASSWORD_ENCRYPT_LIST.includes(config.url)) {
    const source = { ...config.data };
    if (source.password) {
      source.password = sha1Encrypt(source.password);
    }
    if (source.newPassword) {
      source.newPassword = sha1Encrypt(source.newPassword);
    }
    if (source.subPassword) {
      source.subPassword = sha1Encrypt(source.subPassword);
    }
    config.data = source;
  }
  return config;
}

// 平台
export function requestInterceptorsPlatform(
  config: InternalAxiosRequestConfig
) {
  if (!config.url) return config;
  try {
    const PicturePlatforms: number[] = JSON.parse(
      sessionStorage.getItem(STORAGE.PicturePlatforms) || "[]"
    );
    const platform = +(sessionStorage.getItem(STORAGE.PLATFORM) || 0);
    if (PicturePlatforms.includes(platform)) {
      const someSeepupTask = sessionStorage.getItem(STORAGE.SOME_SPEED_UP_TASK);
      const speedUpPlatform = sessionStorage.getItem(STORAGE.SPEED_UP_PLATFORM);
      const platform = sessionStorage.getItem(STORAGE.PLATFORM);
      if (HANDLE_SPEED_UP_LIST.includes(config.url)) {
        config.headers.targetPlatform = platform;
      }
      if (HANDLE_SPEED_UP_LIST_OPERATION.includes(config.url)) {
        const currentClickPlatform = sessionStorage.getItem(
          STORAGE.CURRENT_Click_Platform
        );
        config.headers.targetPlatform = currentClickPlatform;

        if (someSeepupTask && SPECIAL_HUAWEI.includes(config.url)) {
          config.headers.platform = speedUpPlatform || currentClickPlatform;
        }
      }
    } else {
      delete config.headers.targetPlatform;
    }
  } catch (error) {
    console.trace(error);
  }
  return config;
}

export function requestInterceptorsHeaders(config: InternalAxiosRequestConfig) {
  const headers = getHttpHeader() as any;
  config.headers = { ...headers, ...config.headers };
  return config;
}
